import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

export const PENDING_ORGANIZATION_INVITATIONS = gql(`
  query pendingOrganizationInvitations{
    me {
      __typename
      id
      pendingInvitations {
        __typename
        id
        organizationName
        invitedAt
        role
      }
    }
  }
`);

export function usePendingOrganizationInvitations() {
  const { data, ...rest } = useQuery(PENDING_ORGANIZATION_INVITATIONS);

  const pendingInvitation = data?.me.pendingInvitations || [];

  return { ...rest, data: pendingInvitation };
}
